import { render, staticRenderFns } from "./ShippingTariffModal.vue?vue&type=template&id=341f63ce&scoped=true"
import script from "./ShippingTariffModal.vue?vue&type=script&lang=js"
export * from "./ShippingTariffModal.vue?vue&type=script&lang=js"
import style0 from "./ShippingTariffModal.vue?vue&type=style&index=0&id=341f63ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "341f63ce",
  null
  
)

export default component.exports